











import { Component, Watch } from 'vue-property-decorator'

import AppSystemInfoCard from '@/components/AppSystemInfoCard.vue'
import AppFilePreview from '@/components/AppFilePreview.vue'
import detail from '@/modules/Case/views/detail.vue'
import AppAttachmentsCard from '@/components/AppAttachmentsCard.vue'

@Component({
  components: {
    AppSystemInfoCard,
    AppFilePreview,
    AppAttachmentsCard
  }
})
export default class CaseDetailAttachment extends detail {
  get attachmentList () {
    return this.caseInfo.attachments || []
  }
}
